export type LLMErrorCode =
  | 'LLM_UPSTREAM_ERROR'
  | 'LLM_EMPTY_RESPONSE'
  | 'LLM_MISSING_XML_TAG'
  | 'LLM_JSON_PARSE_ERROR'
  | 'LLM_SCHEMA_VALIDATION_ERROR';

export class LLMInteractionError extends Error {
  public readonly code: LLMErrorCode;
  public readonly context?: Record<string, unknown>;
  public readonly cause?: unknown;

  constructor(code: LLMErrorCode, message: string, context?: Record<string, unknown>, cause?: unknown) {
    super(message);
    this.name = 'LLMInteractionError';
    this.code = code;
    this.context = context;
    this.cause = cause;
  }
}

export class LLMUpstreamError extends LLMInteractionError {
  constructor(message: string, context?: Record<string, unknown>, cause?: unknown) {
    super('LLM_UPSTREAM_ERROR', message, context, cause);
    this.name = 'LLMUpstreamError';
  }
}

export class LLMEmptyResponseError extends LLMInteractionError {
  constructor(message: string, context?: Record<string, unknown>) {
    super('LLM_EMPTY_RESPONSE', message, context);
    this.name = 'LLMEmptyResponseError';
  }
}

export class LLMMissingXmlTagError extends LLMInteractionError {
  constructor(message: string, context?: Record<string, unknown>) {
    super('LLM_MISSING_XML_TAG', message, context);
    this.name = 'LLMMissingXmlTagError';
  }
}

export class LLMJsonParseError extends LLMInteractionError {
  constructor(message: string, context?: Record<string, unknown>, cause?: unknown) {
    super('LLM_JSON_PARSE_ERROR', message, context, cause);
    this.name = 'LLMJsonParseError';
  }
}

export class LLMSchemaValidationError extends LLMInteractionError {
  constructor(message: string, context?: Record<string, unknown>, cause?: unknown) {
    super('LLM_SCHEMA_VALIDATION_ERROR', message, context, cause);
    this.name = 'LLMSchemaValidationError';
  }
}
